import React from "react";
import Typewriter from "typewriter-effect";
import "./Home.css";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "FullStack Developer",
          "JavaScript | React.js | Node.js",
          "Colaborador de Código Abierto",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
